import { render, staticRenderFns } from "./BranchEditViewForm.vue?vue&type=template&id=a16f32ee&scoped=true"
import script from "./BranchEditViewForm.vue?vue&type=script&lang=js"
export * from "./BranchEditViewForm.vue?vue&type=script&lang=js"
import style0 from "./BranchEditViewForm.vue?vue&type=style&index=0&id=a16f32ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16f32ee",
  null
  
)

export default component.exports